import { baseAPI } from "./baseService";
import { MALSAPI, SEARCH } from "./serviceConstants";

export const searchAPI = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getSourceByIdForSearch: builder.query({
      query: (arg) => {
        const { pointingName, sourceID, release_name } = arg;
        return {
          url: `${MALSAPI}/${SEARCH}/${release_name}/source/${sourceID}`,
          params: { pointingName },
        };
      },
    }),
    getCatalogueSourceDataForSearch: builder.query({
      query: (arg) => {
        const { ra, dec, radius, release_name, spw } = arg;
        return {
          url: `${MALSAPI}/${SEARCH}/${release_name}/sources`,
          params: { ra, dec, radius, spw },
        };
      },
    }),
    getSourceImagesForSearch: builder.query({
      query: (arg) => {
        const { pointingName, sourceID, release_name } = arg;
        return {
          url: `${MALSAPI}/${SEARCH}/${release_name}/${sourceID}/images`,
          params: { pointingName },
        };
      },
    }),
    gaussSearchDownload: builder.mutation({
      query: ({sourceIds, releaseName}) => {
        return {
          url: `${MALSAPI}/${SEARCH}/${releaseName}/gauss/download`,
          method: "POST",
          body: sourceIds,
          responseHandler: (response) => response.text()
        };
      }
    }),
    getPositionForSearch: builder.query({
      query: (arg) => {
        const { ra, dec, release_name } = arg;
        return {
          url: `${MALSAPI}/${SEARCH}/${release_name}/position`,
          params: { ra, dec },
        };
      },
    }),
    getAllSpwsForSearchCatalogue: builder.query({
      query: (release_cat_name) => {
        return { url: `${MALSAPI}/${SEARCH}/${release_cat_name}/spws` };
      },
    }),
    getAllDataReleases: builder.query({
      query: () => {
        return { url: `${MALSAPI}/${SEARCH}/catalogues` }
      },
    }),
    getReleaseNotes: builder.query({
      query: (releaseName) => {
        releaseName=releaseName+".md";
        return {
          url: `/release_notes/${releaseName}`,
          responseHandler: (response) => response.text(),
        };
      },
      providesTags: ["releasenote"],
    }),
    getSpectralSearchPlotData: builder.query({
      query: ({sourceId,catalogueId}) => {
        return { url: `${MALSAPI}/${SEARCH}/${catalogueId}/${sourceId}/plot` };
    },
    }),
    uploadBatchImagesRequestFile: builder.mutation({
      query: ({  release_name, radius,file }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("radius",radius);
        return {
          url: `${MALSAPI}/${SEARCH}/${release_name}/position/batch/upload`,
          method: "POST",
          body: formData,
        };
      },
    }),
    downloadBatchImageArtefacts: builder.mutation({
      query: ({release_name, fitsPaths }) => {
        return {
          url: `${MALSAPI}/${SEARCH}/${release_name}/position/batch/download`,
          method: "POST",
          body: fitsPaths
        };
      },
    }),
  }),
});

export const {
  useGetSourceByIdForSearchQuery,
  useGetCatalogueSourceDataForSearchQuery,
  useGetPositionForSearchQuery,
  useGetSourceImagesForSearchQuery,
  useGetAllSpwsForSearchCatalogueQuery,
  useGetAllDataReleasesQuery,
  useLazyGetReleaseNotesQuery,
  useGetReleaseNotesQuery,
  useGaussSearchDownloadMutation,
  useLazyGetAllDataReleasesQuery,
  useUploadBatchImagesRequestFileMutation,
  useDownloadBatchImageArtefactsMutation,
  useGetSpectralSearchPlotDataQuery
} = searchAPI;
